<script>
import { mapState } from "vuex";
const ABC = require("@/hamochiABC/ABC/main");
export default {
  components: {
    ApiErrorDialog: () =>
      import(
        /* webpackChunkName: "component-api-error-dialog" */ "@/components/ApiErrorDialog.vue"
      ),
  },
  computed: mapState({
    event: (state) => state.event.data,
    skin: (state) => state.skin.data,
    hatData: (state) => state.apparel.data,
    auth: (state) => state.auth.data,
    settings: (state) => state.settings.data,
    series: (state) => state.series.data,
  }),
  props: [
    //
  ],
  data: () => ({
    startTime: null,
    endTime: null,
    env: process.env,
    noOfRounds: 3,
    containerId: "game-container",
    gameInstance: null,
    bossRound: -1, // make it random
    master: 0,
    music: 0,
    sfx: 0,
    vocabCount: 0,
    screens: 1,
    floors: 6,
    rooms: 5,
    showDifficulty: false,
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    vocabApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    questions: [],
    avatarItem: {
      shadow: null,
      back: null,
      right: null,
      body: null,
      outline: null,
      cheek: null,
      mouth: null,
      eye: null,
      hair: null,
      left: null,
      hat: null,
      color: null,
    },
    friendName: null,
    friendAvatarItem: {
      shadow: null,
      back: null,
      right: null,
      body: null,
      outline: null,
      cheek: null,
      mouth: null,
      eye: null,
      hair: null,
      left: null,
      hat: null,
      color: null,
    },
    avatarData: null,
    avatarBack: null,
    avatarRight: null,
    avatarLeft: null,
    avatarOutline: null,
    avatarMouth: null,
    avatarBody: null,
    avatarShadow: null,
    avatarEye: null,
    avatarHair: null,
    avatarCheek: null,
    avatarColor: null,
    avatarHat: null,
    mouth: [],
    body: [],
    outline: [],
    shadow: [],
    eye: [],
    hair: [],
    cheek: [],
    hat: [],
    left: [],
    right: [],
    back: [],
    stories: [],
  }),
  created() {
    console.log(this.auth)
    this.vocabApi.url =
      this.$api.servers.game +
      "/api/v1/" +
      this.$_getLocale() +
      "/game/vocab/player/count";
    this.vocabApi.callbackReset = () => {
      this.vocabApi.isLoading = true;
      this.vocabApi.isError = false;
      this.vocabApi.error = null;
    };
    this.vocabApi.callbackError = (e) => {
      this.vocabApi.isLoading = false;
      this.vocabApi.isError = true;
      this.vocabApi.error = e;
    };
    this.vocabApi.callbackSuccess = (resp) => {
      console.log(resp);
      this.vocabApi.isLoading = false;
      this.vocabCount = resp.count;
      this.startGame();
    };
  },
  mounted() {
    this.stories = [
      {
        id: 1,
        chapter: "介绍",
        title: "海洋之梦",
        totalStar: 0,
        isCompleted: false,
        isPlayed: false,
        ChapterStep: false,
        unlockStar: 0,
        contents: [
          {
            id: 1,
            key: "01",
            content:
              "明的爸爸是个渔夫。明和他的爸爸把鱼送到市场上卖鱼的人那里。",
            audio: "/assets/gameAssets/abc/sounds/story/0_1_cn.wav",
            wordTimings: false,
          },
          {
            id: 2,
            key: "02",
            content:
              "明听到了一个关于一位传奇的蒙面渔夫钓到一条传奇的彩虹鱼的故事。",
            audio: "/assets/gameAssets/abc/sounds/story/0_2_cn.wav",
            wordTimings: false,
          },
          {
            id: 3,
            key: "03",
            content: "明也想成为一名传奇渔夫。他恳求爸爸带他去大海。",
            audio: "/assets/gameAssets/abc/sounds/story/0_3_cn.wav",
            wordTimings: false,
          },
        ],
      },
      {
        id: 2,
        chapter: "第1章",
        title: "鲍勃大师之旅",
        totalStar: 0,
        isCompleted: false,
        isPlayed: false,
        ChapterStep: [
          {
            actionType: "goMap",
            conditionKey: "success",
          },
          {
            actionType: "goPage",
            conditionKey: "fail",
          },
        ],
        unlockStar: 0,
        contents: [
          {
            id: 1,
            key: "11",
            content:
              "爸爸说他很高兴看到 Mining 有一个大梦想。但是爸爸认为他还没有准备好。",
            audio: "/assets/gameAssets/abc/sounds/story/1_1_cn.wav",
            wordTimings: false,
          },
          {
            id: 2,
            key: "12",
            content:
              "爸爸想支持他的梦想，于是爸爸把明送到他师父那里，训练明成为一名可以完成任务的渔夫。",
            audio: "/assets/gameAssets/abc/sounds/story/1_2_cn.wav",
            wordTimings: false,
          },
          {
            id: 3,
            key: "goal",
            content: "Goal",
            audio: "",
            wordTimings: false,
          },
          {
            id: 4,
            key: "13",
            content:
              "回到家后，鲍勃看到明闪闪发光的眼睛，于是他决定教明如何钓鱼。",
            audio: "/assets/gameAssets/abc/sounds/story/1_3_cn.wav",
            wordTimings: false,
          },
        ],
      },
      {
        id: 3,
        chapter: "第2章",
        title: "竹子挑战",
        totalStar: 0,
        isCompleted: false,
        isPlayed: false,
        ChapterStep: false,
        unlockStar: 1,
        contents: [
          {
            id: 1,
            key: "21",
            content:
              "第一天，鲍勃大师给了明一把斧头，并带他来到竹林。 鲍勃要求他尽可能多地砍竹子。",
            audio: "/assets/gameAssets/abc/sounds/story/2_1_cn.wav",
            wordTimings: false,
          },
          {
            id: 2,
            key: "goal",
            content: "Goal",
            audio: "",
            wordTimings: false,
          },
          {
            id: 3,
            key: "22",
            content: "明一直剪到晚上。鲍勃问他感觉如何。",
            audio: "/assets/gameAssets/abc/sounds/story/2_2_cn.wav",
            wordTimings: false,
          },

          {
            id: 4,
            key: "23",
            content:
              "明说，有的竹子软，有的竹子硬，而令他惊讶的是，有一种红竹，既软又硬！",
            audio: "/assets/gameAssets/abc/sounds/story/2_3_cn.wav",
            wordTimings: false,
          },
          {
            id: 5,
            key: "24",
            content: "但随后他签名，干嘛叫他砍竹子，钓鱼课什么时候才能开？",
            audio: "/assets/gameAssets/abc/sounds/story/2_4_cn.wav",
            wordTimings: false,
          },
          {
            id: 6,
            key: "25",
            content: "鲍勃笑着把他带回家并给他做了一顿美味的鱼菜。",
            audio: "/assets/gameAssets/abc/sounds/story/2_5_cn.wav",
            wordTimings: false,
          },
        ],
      },
      {
        id: 4,
        chapter: "第3章",
        title: "竹子挑战",
        totalStar: 0,
        isCompleted: false,
        isPlayed: false,
        ChapterStep: false,
        unlockStar: 3,
        contents: [
          {
            id: 1,
            key: "31",
            content:
              "第一天，鲍勃大师给了明一把斧头，并带他来到竹林。 鲍勃要求他尽可能多地砍竹子。",
            audio: "/assets/gameAssets/abc/sounds/story/2_1_cn.wav",
            wordTimings: false,
          },
          {
            id: 2,
            key: "goal",
            content: "Goal",
            audio: "",
            wordTimings: false,
          },
          {
            id: 3,
            key: "32",
            content: "明一直剪到晚上。鲍勃问他感觉如何。",
            audio: "/assets/gameAssets/abc/sounds/story/2_2_cn.wav",
            wordTimings: false,
          },

          {
            id: 4,
            key: "33",
            content:
              "明说，有的竹子软，有的竹子硬，而令他惊讶的是，有一种红竹，既软又硬！",
            audio: "/assets/gameAssets/abc/sounds/story/2_3_cn.wav",
            wordTimings: false,
          },
          {
            id: 5,
            key: "34",
            content: "但随后他签名，干嘛叫他砍竹子，钓鱼课什么时候才能开？",
            audio: "/assets/gameAssets/abc/sounds/story/2_4_cn.wav",
            wordTimings: false,
          },
          {
            id: 6,
            key: "35",
            content: "鲍勃笑着把他带回家并给他做了一顿美味的鱼菜。",
            audio: "/assets/gameAssets/abc/sounds/story/2_5_cn.wav",
            wordTimings: false,
          },
        ],
      },
      {
        id: 5,
        chapter: "第4章",
        title: "竹子挑战",
        totalStar: 0,
        isCompleted: false,
        isPlayed: false,
        ChapterStep: false,
        unlockStar: 5,
        contents: [
          {
            id: 1,
            key: "41",
            content:
              "第一天，鲍勃大师给了明一把斧头，并带他来到竹林。 鲍勃要求他尽可能多地砍竹子。",
            audio: "/assets/gameAssets/abc/sounds/story/2_1_cn.wav",
            wordTimings: false,
          },
          {
            id: 2,
            key: "goal",
            content: "Goal",
            audio: "",
            wordTimings: false,
          },
          {
            id: 3,
            key: "42",
            content: "明一直剪到晚上。鲍勃问他感觉如何。",
            audio: "/assets/gameAssets/abc/sounds/story/2_2_cn.wav",
            wordTimings: false,
          },

          {
            id: 4,
            key: "43",
            content:
              "明说，有的竹子软，有的竹子硬，而令他惊讶的是，有一种红竹，既软又硬！",
            audio: "/assets/gameAssets/abc/sounds/story/2_3_cn.wav",
            wordTimings: false,
          },
          {
            id: 5,
            key: "44",
            content: "但随后他签名，干嘛叫他砍竹子，钓鱼课什么时候才能开？",
            audio: "/assets/gameAssets/abc/sounds/story/2_4_cn.wav",
            wordTimings: false,
          },
          {
            id: 6,
            key: "45",
            content: "鲍勃笑着把他带回家并给他做了一顿美味的鱼菜。",
            audio: "/assets/gameAssets/abc/sounds/story/2_5_cn.wav",
            wordTimings: false,
          },
        ],
      },
      {
        id: 14,
        chapter: "Epilogue",
        title: "",
        totalStar: 0,
        isCompleted: false,
        isPlayed: false,
        ChapterStep: false,
        unlockStar: 12,
        content: "",
      },
    ];
    this.startTime = new Date();
    this.avatarData = JSON.parse(this.auth.Player.avatar);
    this.selectSkin(this.avatarData);
    this.$api.fetch(this.vocabApi);
  },
  beforeDestroy() {
    let master = this.settings.audio.master;
    let music = this.settings.audio.music;
    this.$bgMusic.src = require("@/assets/sounds/music_bg_1.mp3");
    this.$bgMusic.volume = music * master;
    this.$bgMusic.play();
  },
  destroyed() {
    if (this.gameInstance) {
      this.gameInstance.destroy(true);
      this.gameInstance = null;
    }
  },
  methods: {
    clickStartGame() {
      this.showDifficulty = false;
      this.startGame();
    },
    startGame() {
      this.gameInstance = ABC.launch(this.containerId);
      this.gameInstance.scene.start("LoadingScene", {
        rooms: this.rooms,
        floors: this.floors,
        screens: this.screens,
        avatar: this.avatarItem,
        vocab: this.vocabCount,
        env: this.env,
        stories: this.stories,
      });
      this.$bgMusic.pause();
      this.$bgMusic.src = null;
    },
    selectSkin(avatarData, isFriend = false) {
      this.body = this.skin.body;
      this.outline = this.skin.outline;
      this.mouth = this.skin.mouth;
      this.shadow = this.skin.shadow;
      this.eye = this.skin.eye;
      this.hair = this.skin.hair;
      this.cheek = this.skin.cheek;
      var outline = avatarData.body;
      var mouth = avatarData.mouth;
      var hat = avatarData.hat;
      var left = avatarData.left;
      var right = avatarData.right;
      var back = avatarData.back;
      var avatarOutline = this.outline.filter(function (entry) {
        return entry.character == outline;
      });
      this.avatarOutline = JSON.parse(avatarOutline[0].images).F0.url;
      var avatarBody = this.body.filter(function (entry) {
        return entry.character == outline;
      });
      this.avatarBody = JSON.parse(avatarBody[0].images).F0.url;
      var avatarMouth = this.mouth.filter(function (entry) {
        return entry.character == mouth;
      });
      this.avatarMouth = JSON.parse(avatarMouth[0].images).F0.url;

      if (hat) {
        var avatarHat = this.hatData.filter(function (entry) {
          return entry.key == hat;
        });
        this.avatarHat = JSON.parse(avatarHat[0].images).apparel.url;
      }
      if (left) {
        var avatarLeft = this.hatData.filter(function (entry) {
          return entry.key == left;
        });
        this.avatarLeft = JSON.parse(avatarLeft[0].images).apparel.url;
      }
      if (right) {
        var avatarRight = this.hatData.filter(function (entry) {
          return entry.key == right;
        });
        this.avatarRight = JSON.parse(avatarRight[0].images).apparel.url;
      }
      if (back) {
        var avatarBack = this.hatData.filter(function (entry) {
          return entry.key == back;
        });
        this.avatarBack = JSON.parse(avatarBack[0].images).apparel.url;
      }

      this.avatarShadow = JSON.parse(this.shadow[0].images).F0.url;
      this.avatarEye = JSON.parse(this.eye[0].images).F0.url;
      this.avatarHair = JSON.parse(this.hair[0].images).F0.url;
      this.avatarCheek = JSON.parse(this.cheek[0].images).F0.url;
      this.avatarColor = avatarData.pColor;
      if (isFriend) {
        this.friendAvatarItem.back = this.avatarBack;
        this.friendAvatarItem.body = this.avatarBody;
        this.friendAvatarItem.eye = this.avatarEye;
        this.friendAvatarItem.hat = this.avatarHat;
        this.friendAvatarItem.left = this.avatarLeft;
        this.friendAvatarItem.mouth = this.avatarMouth;
        this.friendAvatarItem.right = this.avatarRight;
        this.friendAvatarItem.shadow = this.avatarShadow;
        this.friendAvatarItem.outline = this.avatarOutline;
        this.friendAvatarItem.cheek = this.avatarCheek;
        this.friendAvatarItem.hair = this.avatarHair;
        this.friendAvatarItem.color = this.avatarColor;
        this.startGame();
      } else {
        this.avatarItem.back = this.avatarBack;
        this.avatarItem.body = this.avatarBody;
        this.avatarItem.eye = this.avatarEye;
        this.avatarItem.hat = this.avatarHat;
        this.avatarItem.left = this.avatarLeft;
        this.avatarItem.mouth = this.avatarMouth;
        this.avatarItem.right = this.avatarRight;
        this.avatarItem.shadow = this.avatarShadow;
        this.avatarItem.outline = this.avatarOutline;
        this.avatarItem.cheek = this.avatarCheek;
        this.avatarItem.hair = this.avatarHair;
        this.avatarItem.color = this.avatarColor;
      }
    },
  },
};
</script>

<template>
  <!-- <transition name="fade" mode="out-in"> -->
  <div class="screen-wrap">
    <v-app class="hmc-app">
      <v-main class="main-body">
        <v-container class="game-body">
          <!-- BOC:[error] -->
          <ApiErrorDialog v-if="api.isError" :api="api" />
          <ApiErrorDialog v-if="vocabApi.isError" :api="vocabApi" />
          <!-- EOC -->
          <div
            class="d-flex flex-column justify-center align-center dif"
            v-if="showDifficulty"
          >
            <div class="justify-left px-6" style="width: 300px">
              <v-text-field
                v-model="screens"
                label="Screen count for map"
                type="number"
                color="ash"
                suffix="screens"
                :step="1"
                :min="1"
                :max="100"
              ></v-text-field>
              <v-text-field
                v-model="floors"
                label="No of floors in a map"
                type="number"
                color="ash"
                suffix="floors"
                :step="1"
                :min="4"
                :max="100"
              ></v-text-field>
              <v-text-field
                v-model="rooms"
                label="No of rooms in a floor"
                type="number"
                color="ash"
                suffix="rooms"
                :step="1"
                :min="1"
                :max="10"
              ></v-text-field>
              <div class="mb-6 pb-6">
                <v-btn class="ma-2" @click="clickStartGame()" width="260"
                  >Start game</v-btn
                >
              </div>
            </div>
          </div>

          <div
            :id="containerId"
            style="max-width: 480px; padding: 0; max-height: 100vh !important"
          />
          <div
            v-if="!gameInstance && !showDifficulty"
            style="position: absolute"
            class="d-flex align-center justify-center flex-column"
          >
            <v-progress-linear
              color="brown darken-1"
              indeterminate
              height="10"
              style="max-width: 200px"
              class="my-5"
            ></v-progress-linear>
            <span class="brown--text py-2">
              {{ $t("string.game_loading_msg") }}</span
            >

            <v-btn
              depressed
              color="brown lighten-3"
              class="brown--text text--darken-3"
              @click="
                () => {
                  $router.go($router.currentRoute);
                }
              "
            >
              ↻ {{ $t("action.retry") }}
            </v-btn>
          </div>
        </v-container>
      </v-main>
    </v-app>
  </div>
  <!-- </transition> -->
</template>

<style>
.game-body {
  max-width: 480px;
  height: calc(100% - 10px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;

  /* background-color: #f5dfc5; */
}

.main-body {
  /* background-color: #f5dfc5; */
  background-color: rgba(214, 132, 49, 0.3);
  position: relative;
}
.dif {
  /* padding-top: 500px; */
  position: absolute;
  height: 100vh;
  overflow-y: scroll;
  width: 100%;
  /* overflow: hidden; */
}
</style>